<template>
    <div :class="['step', 'row', 'no-padding', 'parameters-' + type]">
        <div v-if="type === 'flat'" class="col-md-6">
            <div class="form-group">
                <label for="floor_area"><strong>Podlahová plocha*</strong></label>
                <input id="floor_area" type="number" name="floor_area" v-on:focus="setPicture('floor')" v-model="floorArea">
                <label for="floor_area">m<sup>2</sup></label>
            </div>
            <div class="form-group">
                <label for="balcony_area">Balkón + Lodžie + Terasa</label>
                <input id="balcony_area" type="number" name="balcony_area" v-on:focus="setPicture('balcony')">
                <label for="balcony_area">m<sup>2</sup></label>
            </div>
            <div class="form-group">
                <label for="garden_area">Vlastní zahrada</label>
                <input id="garden_area" type="number" name="garden_area" v-on:focus="setPicture('garden')">
                <label for="garden_area">m<sup>2</sup></label>
            </div>
            <div class="form-group">
                <label for="cellar_area">Sklep</label>
                <input id="cellar_area" type="number" name="cellar_area" v-on:focus="setPicture('cellar')">
                <label for="cellar_area">m<sup>2</sup></label>
            </div>
        </div>
        <div v-else class="col-md-6">
            <div class="form-group">
                <label for="floor_area"><strong>Podlahová plocha*</strong></label>
                <input id="floor_area" type="number" name="floor_area" v-on:focus="setPicture('floor')" v-model="floorArea">
                <label for="floor_area">m<sup>2</sup></label>
            </div>
            <div class="form-group">
                <label for="cellar_area">Sklep</label>
                <input id="cellar_area" type="number" name="cellar_area" v-on:focus="setPicture('cellar')">
                <label for="cellar_area">m<sup>2</sup></label>
            </div>
            <div class="form-group">
                <label for="garage_area">Garáž</label>
                <input id="garage_area" type="number" name="garage_area" v-on:focus="setPicture('garage')">
                <label for="garage_area">m<sup>2</sup></label>
            </div>
            <div class="form-group">
                <label for="other_area">Neobyvatelná plocha</label>
                <input id="other_area" type="number" name="other_area" v-on:focus="setPicture('workshop')">
                <label for="other_area">m<sup>2</sup></label>
            </div>
            <div class="form-group">
                <label for="lot_area">Plocha pozemku</label>
                <input id="lot_area" type="number" name="lot_area" v-on:focus="setPicture('lot')">
                <label for="lot_area">m<sup>2</sup></label>
            </div>
        </div>
        <div class="col-md-6 focused-input-image">
            <img :src="assetsUrl + '/' + type + '/' + picture + '.png'" class="img-fluid">
        </div>
    </div>
</template>

<script>
    export default {
        name: "Parameters",

        props: ['assetsUrl'],

        data: function() {
            return {
                picture: 'nothing',
                floorArea: null
            }
        },

        computed: {
            type: function () {
                let type = this.$parent.getType();
                if (type == "cottage") {
                    type = "house";
                }

                this.picture = 'nothing';

                return type;
            },

            required: function () {
                return parseInt(this.floorArea) != 'NaN' && parseInt(this.floorArea) > 0;
            }
        },

        methods: {
            setPicture: function (picture) {
                this.picture = picture;
            }
        }
    }
</script>

<style scoped>
    .form-group label:first-of-type, .form-group input {
        display: inline-block;
        width: 45%;
    }

    .parameters-flat .focused-input-image {
        padding: 0 95px;
    }

    .parameters-house .focused-input-image {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media (max-width: 1199px) {
        .parameters-flat .focused-input-image {
            padding: 0 50px;
        }
    }

    @media (max-width: 991px) {
        .parameters-flat .focused-input-image {
            padding: 0;
        }
    }

    @media (max-width: 767px) {
        .parameters-flat .focused-input-image, .parameters-house .focused-input-image  {
            display: none;
        }
    }
</style>